// extracted by mini-css-extract-plugin
export default {"subHeader":"Announcements_subHeader__skw4U"};